import AddSupplier from '../../../../../../client/src/rfq/src/viewmodel/AddSupplierViewModel'
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesAddSupplier extends DesBaseRfq {

    constructor() {
        super(AddSupplier);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}

if (!window.customElements.get('des-add-supplier')) {
    window.customElements.define('des-add-supplier', DesAddSupplier);
}
